<template>
  <div class="fill-and-flex">
    <div
      class="flex-shrink-0 bg-blue-600 text-sm text-blue-300 flex justify-between items-center"
    >
      <ion-icon
        name="chevron-back-outline"
        class="px-2 fs-4"
        :class="{ 'opacity-50': disablePrev }"
        @click="prevResult"
      />
      <div class="flex py-3" @click="showKeywordResultsModal">
        <div class="flex-shrink-0">showing results for</div>
        <SkeletonLine
          :val="resultToUse"
          variant="light"
          class="flex-shrink-1 ml-1 inline-flex items-center min-w-0 cursor-pointer"
        >
          <template v-if="resultToUse">
            <span class="font-bold underline text-blue-200 truncate">{{
              resultToUse
            }}</span>
            <ion-icon name="caret-down-outline" class="text-blue-400" />
          </template>
        </SkeletonLine>
      </div>
      <ion-icon
        name="chevron-forward-outline"
        class="px-2 fs-4"
        :class="{ 'opacity-50': disableNext }"
        @click="nextResult"
      />
    </div>
    <KeywordResultsModal
      :result="result"
      :searching="searching"
      :search-value="searchValue"
      @close="hideKeywordResultsModal"
      @result-selected="index => changeResult(index)"
      v-if="keywordResultsModalWasVisible"
      v-show="keywordResultsModalVisible"
    />
    <NumResults :search-value="resultToUse" :key="resultToUse" />
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

import KeywordResultsModal from "@/views/Home/KeywordResults/Modal";
import NumResults from "@/views/Home/NumResults";
import SkeletonLine from "@/components/SkeletonLine";

import { API_ENDPOINT } from "@/app.config";

import router from "@/router";

import { formatNumUriString, responseSuccessful } from "@/utils/utils";

export default {
  name: "KeywordResultsBar",
  components: {
    KeywordResultsModal,
    NumResults,
    SkeletonLine,
  },
  props: {
    searchValue: String,
  },
  data() {
    return {
      result: null,
      resultIndex:
        (typeof this.$route.query.i === "string" &&
          !isNaN(parseFloat(this.$route.query.i)) &&
          parseFloat(this.$route.query.i)) ||
        0,
      searching: null,
      keywordResultsModalWasVisible: false, // if was visible keep in DOM to stop retriggering NUM queries
      keywordResultsModalVisible: false,
    };
  },
  computed: {
    ...mapState(["settings"]),
    disablePrev() {
      return !this.result || this.resultIndex === 0;
    },
    disableNext() {
      return !this.result || this.resultIndex + 1 === this.result.length;
    },
    resultToUse() {
      const numUriString = this.result?.[this.resultIndex]?.numUri;
      return numUriString && formatNumUriString(numUriString);
    },
  },
  watch: {
    resultIndex(newVal) {
      router.push({
        query: {
          ...this.$route.query,
          i: newVal,
        },
      });
    },
    searchValue: {
      handler(newVal) {
        this.keywordSearch(newVal);
      },
      immediate: true,
    },
  },
  methods: {
    changeResult(index) {
      this.hideKeywordResultsModal();
      this.resultIndex = index;
    },
    hideKeywordResultsModal() {
      this.keywordResultsModalVisible = false;
    },
    async keywordSearch(input) {
      this.searching = true;

      const response = await axios({
        data: {
          country: this.settings?.countryCode,
          keywords: input,
          language: this.settings?.languageCode,
        },
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        method: "post",
        url: `${API_ENDPOINT}/keyword/contacts`,
      })
        .then(response => response)
        .catch(error => error.response);

      if (responseSuccessful(response)) {
        this.result = response.data;
        this.searching = false;
      }
    },
    nextResult() {
      if (!this.disableNext) this.resultIndex += 1;
    },
    prevResult() {
      if (!this.disablePrev) this.resultIndex -= 1;
    },
    showKeywordResultsModal() {
      this.keywordResultsModalWasVisible = true;
      this.keywordResultsModalVisible = true;
    },
  },
};
</script>
